import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { Schema, Subtemplate, Template } from "PFTypes";

const getAvailableBookingCategoryValuesFromProperties = (
  subTemplateProperties: Subtemplate["properties"]
): number[] => {
  const subTemplateBookingCategoryValues = subTemplateProperties?.booking_category_id?.values ?? [];

  return map(subTemplateBookingCategoryValues, Number);
};

type GetAvailableBookingCategoryValues = {
  isRole: boolean;
  isEngagement: boolean;
  engagementSchema: Schema | undefined;
  parentActivitySubtemplateKey: string | undefined;
  subtemplateKey: string | undefined;
  template: Template;
};

export const getAvailableBookingCategoryValues = ({
  isRole,
  isEngagement,
  engagementSchema,
  parentActivitySubtemplateKey,
  subtemplateKey,
  template
}: GetAvailableBookingCategoryValues): number[] => {
  if (!isEngagement && !isRole) {
    return [];
  }
  if (isRole) {
    const [, parentSubtemplate] =
      Object.entries(engagementSchema?.subtemplates ?? {}).find(
        ([key]) => key === parentActivitySubtemplateKey
      ) || [];

    const [, selectedSubtemplate] =
      Object.entries(template.schema.subtemplates ?? {}).find(([key]) => key === subtemplateKey) || [];

    const roleAvailableBookingCategoryValues = getAvailableBookingCategoryValuesFromProperties(
      selectedSubtemplate?.properties
    );

    const engagementAvailableBookingCategoryValues = getAvailableBookingCategoryValuesFromProperties(
      parentSubtemplate?.properties
    );

    const availableBookingCategoryValues = !isEmpty(roleAvailableBookingCategoryValues)
      ? roleAvailableBookingCategoryValues
      : engagementAvailableBookingCategoryValues;

    return availableBookingCategoryValues;
  }

  const [, selectedSubtemplate] =
    Object.entries(template.schema?.subtemplates ?? {}).find(([key]) => key === subtemplateKey) || [];

  return getAvailableBookingCategoryValuesFromProperties(selectedSubtemplate?.properties);
};
